import { Video as VideoIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from 'cn';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from 'components/ui/dropdown-menu';

interface VideoMenuVideo {
    id: string | number;
    source: { name: string };
}

interface VideoMenuProps {
    videos: VideoMenuVideo[];
    className?: string;
}

export default function VideoMenu(props: VideoMenuProps) {
    const navigate = useNavigate();

    return (
        <div className={cn(props.className)}>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <button
                        type="button"
                        aria-label="Watch video"
                        className="inline-flex h-8 w-8 items-center justify-center rounded-full text-foreground/70 hover:bg-muted hover:text-foreground">
                        <VideoIcon className="h-4 w-4" />
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    {props.videos.map((video) => (
                        <DropdownMenuItem
                            key={video.id}
                            onClick={() => navigate('/video/' + video.id)}>
                            Watch on {video.source.name}
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
}
